import { render, staticRenderFns } from "./SubMasterTable.vue?vue&type=template&id=213a2671"
import script from "./SubMasterTable.vue?vue&type=script&lang=js"
export * from "./SubMasterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports